import { useState, useEffect, useContext } from "react";
import { sendApiRequest } from "../../services/Base/base-service";
import { useNavigate } from "react-router-dom";
import { useSignIn, useSignOut } from "react-auth-kit";
import UserContext from "../../store/user-context";
import {
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Button,
  Icon,
  Alert,
  Spinner,
} from "design-react-kit";

const ExternalFlowErrorsModal = ({
  modalOpen,
  modalCloseHandler,
  selectedFlow,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [externalFlowErrors, setExternalFlowErrors] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const signIn = useSignIn();
  const signOut = useSignOut();

  const userContext = useContext(UserContext);

  useEffect(() => {
    if (modalOpen) {
      setIsLoading(true);
      setError(null);
      setExternalFlowErrors(null);
      sendApiRequest(
        `ExternalFlow/GetValidationErrors?externalFlowId=${selectedFlow.id}`,
        "GET",
        true,
        null,
        signIn,
        signOut,
        navigate,
        null,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
          } else {
            setExternalFlowErrors(response.data);
          }
          setIsLoading(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  const csvFileInfo =
    externalFlowErrors?.externalFlowValidationZipFileContentInfo?.csvFileInfo;

  const hasGeneralError =
    externalFlowErrors !== null && externalFlowErrors.generalErrorInfo !== null;

  const hasMissingFileInZip = csvFileInfo?.pdfFileNamesMissingInZip?.length > 0;

  const hasMissingFileInCsv = csvFileInfo?.pdfFileNamesMissingInCsv?.length > 0;

  const hasDuplicateFilesInCsv =
    csvFileInfo?.pdfFileNamesDuplicateInCsv?.length > 0;

  const hasWrongFilesInZipSign =
    externalFlowErrors?.externalFlowValidationZipFileSignContentInfo
      ?.pdfFileNamesWrongInZipSign?.length > 0;

  const hasMissingFilesInZipSign =
    externalFlowErrors?.externalFlowValidationZipFileSignContentInfo
      ?.pdfFileNamesMissingInZipSign?.length > 0;

  const listNotSignedFilesInZipSign = (pdfFileInfos) => {
    return pdfFileInfos?.filter((obj) => obj.isValid && !obj.isSigned);
  };

  const listNotValidFilesInZipSign = (pdfFileInfos) => {
    return pdfFileInfos?.filter((obj) => !obj.isValid);
  };
  const notSignedFilesInZipSign = listNotSignedFilesInZipSign(
    externalFlowErrors?.externalFlowValidationZipFileSignContentInfo
      ?.pdfFileInfos
  );
  const notValidFilesInZipSign = listNotValidFilesInZipSign(
    externalFlowErrors?.externalFlowValidationZipFileSignContentInfo
      ?.pdfFileInfos
  );
  const hasNotSignedFilesInZipSign = notSignedFilesInZipSign?.length > 0;
  const hasNotValidFilesInZipSign = notValidFilesInZipSign?.length > 0;

  const saveData = (function () {
    var a = document.createElement("a");
    return function (data, fileName) {
      var blobData = data
        .replaceAll("<li>", "  - ")
        .replaceAll("</li>", "\r\n")
        .replaceAll("<div><div>", "")
        .replaceAll("</div></div>", "")
        .replaceAll("<ul>", "\r\n")
        .replaceAll("</ul>", "\r\n")
        .replaceAll("<h6>", "")
        .replaceAll("</h6>", "")
        .replaceAll("</div><div>", "");

      var blob = new Blob([blobData], { type: "text/plain;charset=utf-8" }),
        url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    };
  })();

  function exportErrorsHandler() {
    const data =
      `Errori flusso esterno - ${selectedFlow?.zipFileName} \r\n\r\n` +
      document.getElementById("ExternalFlowErrorsBody").innerHTML;
    saveData(data, `errori-${selectedFlow?.zipFileName}.txt`);
  }

  return (
    <Modal
      isOpen={modalOpen}
      toggle={modalCloseHandler}
      align="center"
      scrollable
      labelledBy="externalFlowErrors"
    >
      <ModalHeader toggle={modalCloseHandler} id="externalFlowErrors">
        <h5 className="text-center">
          Errori flusso esterno - {selectedFlow?.zipFileName}
        </h5>
      </ModalHeader>
      <ModalBody id="ExternalFlowErrorsBody">
        <div>
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mx-auto">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          {isLoading && (
            <p style={{ height: "50px" }}>
              <Spinner double active />
            </p>
          )}
          {hasGeneralError && (
            <div className="mb-2">
              <h6>Errore generico</h6>
              {externalFlowErrors.generalErrorInfo}
            </div>
          )}
          {hasMissingFileInZip && (
            <div className="mb-2">
              <h6>Pdf mancanti nel archivio</h6>
              <ul>
                {csvFileInfo.pdfFileNamesMissingInZip.map((file) => (
                  <li key={file.fileName}>{file.fileName}</li>
                ))}
              </ul>
            </div>
          )}
          {hasMissingFileInCsv && (
            <div className="mb-2">
              <h6>Pdf mancanti nel file csv</h6>
              <ul>
                {csvFileInfo.pdfFileNamesMissingInCsv.map((file) => (
                  <li key={file.fileName}>{file.fileName}</li>
                ))}
              </ul>
            </div>
          )}
          {hasDuplicateFilesInCsv && (
            <div className="mb-2">
              <h6>Pdf duplicati nel file csv</h6>
              <ul>
                {csvFileInfo.pdfFileNamesDuplicateInCsv.map((file) => (
                  <li key={file.fileName}>{file.fileName}</li>
                ))}
              </ul>
            </div>
          )}

          {hasNotValidFilesInZipSign && (
            <div className="mb-2">
              <h6>Pdf non validi nel archivio</h6>
              <ul>
                {notValidFilesInZipSign.map((file) => (
                  <li key={file.fileName}>{file.fileName}</li>
                ))}
              </ul>
            </div>
          )}

          {hasNotSignedFilesInZipSign && (
            <div className="mb-2">
              <h6>Pdf non firmati nel archivio</h6>
              <ul>
                {notSignedFilesInZipSign.map((file) => (
                  <li key={file.fileName}>{file.fileName}</li>
                ))}
              </ul>
            </div>
          )}

          {hasWrongFilesInZipSign && (
            <div className="mb-2">
              <h6>Nome file pdf firmato non corretto nel archivio</h6>
              <ul>
                {externalFlowErrors?.externalFlowValidationZipFileSignContentInfo?.pdfFileNamesWrongInZipSign.map(
                  (file) => (
                    <li key={file.fileName}>{file.fileName}</li>
                  )
                )}
              </ul>
            </div>
          )}

          {hasMissingFilesInZipSign && (
            <div className="mb-2">
              <h6>Pdf firmato non presente nel archivio</h6>
              <ul>
                {externalFlowErrors?.externalFlowValidationZipFileSignContentInfo?.pdfFileNamesMissingInZipSign?.map(
                  (file) => (
                    <li key={file.fileName}>{file.fileName}</li>
                  )
                )}
              </ul>
            </div>
          )}
        </div>
      </ModalBody>
      <div className="footer mt-3">
        <FormGroup className="col-sm-12 mb-2 d-flex align-items-center justify-content-end ">
          <Button
            color="white"
            className="mr-2"
            onClick={modalCloseHandler}
            id="user-cancel"
          >
            Annulla
          </Button>
          <Button
            color="primary"
            className="mr-1 rounded-0"
            style={{ padding: "7px 15px" }}
            onClick={() => exportErrorsHandler()}
          >
            <Icon icon="it-print" fill="#fff" className="mr-2" />
            Esporta
          </Button>
        </FormGroup>
      </div>
    </Modal>
  );
};

export default ExternalFlowErrorsModal;
